import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0dfed8b0")

_pushScopeId("data-v-0dfed8b0")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, null, -1)
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "p-mt-3" }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = { key: 5 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GlossaryUsageInfoDialogWordsColumnList = _resolveComponent("GlossaryUsageInfoDialogWordsColumnList")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Dialog, {
      style: _ctx.glossaryUsageDescriptor.dialog.style,
      header: _ctx.$t('managers.glossary.glossaryUsage.details'),
      visible: _ctx.visible,
      modal: true,
      class: "p-fluid kn-dialog--toolbar--primary",
      closable: false
    }, {
      footer: _withId(() => [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withId(() => [
        (_ctx.contentInfo && _ctx.contentInfo.CONTENT_ID)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("ul", null, [
                _createVNode("li", null, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('common.name')) + ":", 1),
                  _createVNode("p", null, _toDisplayString(_ctx.contentInfo.CONTENT_NM), 1)
                ]),
                _createVNode("li", null, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.common.code')) + ":", 1),
                  _createVNode("p", null, _toDisplayString(_ctx.contentInfo.CONTENT_CD), 1)
                ]),
                _createVNode("li", null, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('common.description')) + ":", 1),
                  _createVNode("p", null, _toDisplayString(_ctx.contentInfo.CONTENT_DS), 1)
                ])
              ])
            ]))
          : (_ctx.contentInfo.WORD_ID)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode("ul", null, [
                  _createVNode("li", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.$tc('managers.glossary.common.word', 1)) + ":", 1),
                    _createVNode("p", null, _toDisplayString(_ctx.contentInfo.WORD), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.common.status')) + ":", 1),
                    (_ctx.contentInfo.STATE_NM)
                      ? (_openBlock(), _createBlock("p", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.glossaryUsageDescriptor.translation[_ctx.contentInfo.STATE_NM])), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.common.category')) + ":", 1),
                    (_ctx.contentInfo.CATEGORY_NM)
                      ? (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.glossaryUsageDescriptor.translation[_ctx.contentInfo.CATEGORY_NM])), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('common.description')) + ":", 1),
                    _createVNode("p", null, _toDisplayString(_ctx.contentInfo.DESCR), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.common.formula')) + ":", 1),
                    _createVNode("p", null, _toDisplayString(_ctx.contentInfo.FORMULA), 1)
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.common.link')) + ":", 1),
                    _createVNode("ul", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contentInfo.LINK, (link, index) => {
                        return (_openBlock(), _createBlock("li", { key: index }, [
                          _createVNode("span", null, [
                            _createVNode("p", null, _toDisplayString(link.WORD), 1),
                            (index != _ctx.contentInfo.LINK.length - 1)
                              ? (_openBlock(), _createBlock("a", _hoisted_5, "-"))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createVNode("li", null, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.common.attributes')) + ":", 1),
                    _createVNode("ul", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contentInfo.SBI_GL_WORD_ATTR, (attribute, index) => {
                        return (_openBlock(), _createBlock("li", { key: index }, [
                          _createVNode("p", null, _toDisplayString(attribute.ATTRIBUTE_NM) + ":", 1),
                          _hoisted_6,
                          _createVNode("ul", null, [
                            _createVNode("li", null, _toDisplayString(attribute.VALUE), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : (_ctx.contentInfo.type && _ctx.contentInfo.type === 'document')
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('common.label')) + ":", 1),
                      _createVNode("p", null, _toDisplayString(_ctx.contentInfo.data.label), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('common.name')) + ":", 1),
                      _createVNode("p", null, _toDisplayString(_ctx.contentInfo.data.name), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.glossaryUsage.hierarchyScope')) + ":", 1),
                      _createVNode("p", null, _toDisplayString(_ctx.contentInfo.data.functionalities[0]), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.glossaryUsage.profiledVisibility')) + ":", 1),
                      _createVNode("ul", _hoisted_8, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contentInfo.data.access, (link, index) => {
                          return (_openBlock(), _createBlock("li", {
                            class: "inline-list-item",
                            key: index
                          }, _toDisplayString(link), 1))
                        }), 128))
                      ])
                    ]),
                    _createVNode(_component_GlossaryUsageInfoDialogWordsColumnList, {
                      selectedWords: _ctx.selectedWords,
                      wordsList: _ctx.contentInfo.data.words
                    }, null, 8, ["selectedWords", "wordsList"])
                  ])
                ]))
              : (_ctx.contentInfo.type && _ctx.contentInfo.type === 'dataset')
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    _createVNode("ul", null, [
                      _createVNode("li", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('common.label')) + ":", 1),
                        _createVNode("p", null, _toDisplayString(_ctx.contentInfo.data.DataSet.label), 1)
                      ]),
                      _createVNode("li", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('common.name')) + ":", 1),
                        _createVNode("p", null, _toDisplayString(_ctx.contentInfo.data.DataSet.name), 1)
                      ]),
                      _createVNode("li", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('common.type')) + ":", 1),
                        _createVNode("p", null, _toDisplayString(_ctx.contentInfo.data.DataSet.type), 1)
                      ]),
                      _createVNode("li", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.glossaryUsage.dataSource')) + ":", 1),
                        _createVNode("p", null, _toDisplayString(_ctx.contentInfo.data.DataSet.configuration.dataSource), 1)
                      ]),
                      _createVNode(_component_GlossaryUsageInfoDialogWordsColumnList, {
                        selectedWords: _ctx.selectedWords,
                        wordsList: _ctx.contentInfo.data.Word,
                        columnList: _ctx.contentInfo.data.SbiGlDataSetWlist,
                        columnField: 'alias'
                      }, null, 8, ["selectedWords", "wordsList", "columnList"])
                    ])
                  ]))
                : (_ctx.contentInfo.type && _ctx.contentInfo.type === 'businessClass')
                  ? (_openBlock(), _createBlock("div", _hoisted_10, [
                      _createVNode("ul", null, [
                        _createVNode("li", null, [
                          _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.glossaryUsage.metaModel')) + ":", 1),
                          _createVNode("p", null, _toDisplayString(_ctx.contentInfo.data.metaBc.sbiMetaModel.name), 1)
                        ]),
                        _createVNode("li", null, [
                          _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.glossaryUsage.businessClass')) + ":", 1),
                          _createVNode("p", null, _toDisplayString(_ctx.contentInfo.data.metaBc.name), 1)
                        ]),
                        _createVNode(_component_GlossaryUsageInfoDialogWordsColumnList, {
                          selectedWords: _ctx.selectedWords,
                          wordsList: _ctx.contentInfo.data.words,
                          columnList: _ctx.contentInfo.data.sbiGlBnessClsWlist,
                          columnField: 'name'
                        }, null, 8, ["selectedWords", "wordsList", "columnList"])
                      ])
                    ]))
                  : (_ctx.contentInfo.type && _ctx.contentInfo.type === 'table')
                    ? (_openBlock(), _createBlock("div", _hoisted_11, [
                        _createVNode("ul", null, [
                          _createVNode("li", null, [
                            _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.glossaryUsage.metaSource')) + ":", 1),
                            _createVNode("p", null, _toDisplayString(_ctx.contentInfo.data.metaSource.name), 1)
                          ]),
                          _createVNode("li", null, [
                            _createVNode("span", null, _toDisplayString(_ctx.$t('common.label')) + ":", 1),
                            _createVNode("p", null, _toDisplayString(_ctx.contentInfo.data.metaTable.name), 1)
                          ]),
                          _createVNode(_component_GlossaryUsageInfoDialogWordsColumnList, {
                            selectedWords: _ctx.selectedWords,
                            wordsList: _ctx.contentInfo.data.words,
                            columnList: _ctx.contentInfo.data.sbiGlTableWlist,
                            columnField: 'name'
                          }, null, 8, ["selectedWords", "wordsList", "columnList"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["style", "header", "visible"])
  ]))
})